<script setup>
import { ref, reactive } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['create']);

const dialogRef = ref(null);
const isSubmitting = ref(false);

const form = reactive({
  name: '',
  description: '',
});

const nameError = ref('');

const open = () => {
  form.name = '';
  form.description = '';
  nameError.value = '';
  dialogRef.value?.open();
};

const close = () => {
  dialogRef.value?.close();
};

const handleConfirm = () => {
  nameError.value = '';

  if (!form.name.trim()) {
    nameError.value = 'Nome e obrigatorio';
    return;
  }

  isSubmitting.value = true;
  emit('create', {
    name: form.name.trim(),
    description: form.description.trim(),
  });
};

const stopLoading = () => {
  isSubmitting.value = false;
};

defineExpose({ open, close, stopLoading });
</script>

<template>
  <Dialog
    ref="dialogRef"
    title="Criar Pipeline do Zero"
    confirm-button-label="Criar Pipeline"
    :is-loading="isSubmitting"
    :disable-confirm-button="!form.name.trim()"
    width="md"
    @confirm="handleConfirm"
  >
    <div class="space-y-4">
      <!-- Nome -->
      <label class="block">
        <span class="block text-sm font-medium text-n-slate-12 mb-1.5">
          Nome do Pipeline *
        </span>
        <input
          v-model="form.name"
          type="text"
          placeholder="Ex: Vendas B2B"
          class="w-full px-3 py-2.5 text-sm border rounded-lg bg-n-surface-1 hover:border-n-slate-6 focus:outline-none focus:border-n-brand transition-colors"
          :class="nameError ? 'border-n-ruby-9' : 'border-n-weak'"
          @input="nameError = ''"
        />
        <p v-if="nameError" class="mt-1 text-xs text-n-ruby-11">
          {{ nameError }}
        </p>
      </label>

      <!-- Descrição -->
      <label class="block">
        <span class="block text-sm font-medium text-n-slate-12 mb-1.5">
          Descricao
        </span>
        <textarea
          v-model="form.description"
          rows="3"
          placeholder="Descreva o objetivo deste pipeline..."
          class="w-full px-3 py-2.5 text-sm border border-n-weak rounded-lg bg-n-surface-1 hover:border-n-slate-6 focus:outline-none focus:border-n-brand transition-colors resize-none"
        />
      </label>
    </div>
  </Dialog>
</template>
